import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  buttonContainer: {
    padding: theme.spacing(2, 3),
  },
}));

export default useStyles;
